import { Typography, Button, Grid } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useNavigate } from 'react-router';



function MemberPageHeader() {
  const navigate = useNavigate();

  const handleMembersPage = () => {
    navigate('/members/add');
  } 
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          Members
        </Typography>

      </Grid>
      <Grid item>
        <Button
          sx={{ mt: { xs: 2, md: 0 } }}
          variant="contained"
          onClick={handleMembersPage}
          startIcon={<AddTwoToneIcon fontSize="small" />}
        >
          Create Members
        </Button>
      </Grid>
    </Grid>
  );
}

export default MemberPageHeader;
